export default {"src":"/_next/static/media/instagram-footer.0eb0483d.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};